import React, { Component } from "react";

export const Radio = props => {
	const { className, id, label, checked, changeAction, value, align, name } = props;
	return (
		<div className={align}>
      <input
      	type="radio"
        className={`with-gap ${className}`}
      	id={id}
      	checked={checked}
      	onClick={changeAction}
      	onChange={() => null}
        value={value}
        name={name}
    	/>
      <label htmlFor={id}>{label}</label>
    </div>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/Radio.js